import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ContentIcon, { HEADING_EXHIBITORS } from "ContentIcon";
import {
  fetchExhibitors,
  searchExhibitors,
  sortByName,
  fetchProductAllCategory,
  fetchProductAllSubCategory,
  getExhibitorCounts,
} from "ActionsExhibitors";
import { fetchUserList, fetchEventDetails } from "DashboardUserAction";
import { fetchAllTickets, fetchSettings } from "TicketAction";
import { screenHeightLeftFromTop } from "Constants";
import ExhibitorsList from "ExhibitorsList";
import AddExhibitor from "AddExhibitor";
import ExportExhibitor from "./export-exhibitor";
import ImportExhibitorDialog from "./import-exhibitor";
import InfoTutorial from "InfoTutorial";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Exhibitors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      pageNumber: 1,
      executed: false,
      sort: "randomly",
      loading: true,
      desc: LocaleStrings.preparingExhibitors,
      afterpagi: false,
    };
    this.paginationCallback = this.paginationCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.contentAvailable) {
      this.props.fetchProductAllCategory(this.props.session);
      this.props.fetchProductAllSubCategory(this.props.session);
      this.props.fetchSettings(this.props.session);
      this.props.fetchAllTickets(this.props.session);
      this.props.getExhibitorCounts(this.props.session);
      this.props.fetchEventDetails(this.props.session);
      this.props.fetchExhibitors(this.props.session, 0, (callback) => {
        this.setState({ loading: false });
      });
      setTimeout(() => {
        this.props.fetchUserList(this.props.session);
      }, 100);
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        this.setState({ executed: true });
        setTimeout(() => {
          this.props.fetchExhibitors(this.props.session, 0, (callback) => {});
        }, 400);
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  handleSortByName = (ev) => {
    var sort = ev.target.value;
    var pageNumber = 1;

    if (sort == "az") {
      this.props.sortByName(this.props.session, sort);
    } else {
      this.props.fetchExhibitors(this.props.session, 0, (callback) => {});
    }

    this.setState({ sort, pageNumber, search: "" });
  };

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchExhibitors(this.props.session, 0, (callback) => {});
    } else {
      this.props.searchExhibitors(this.props.session, search, 0);
    }
    this.setState({ search, pageNumber, sort: "randomly" });
  };

  additionCallback = () => {
    // after update call this method with page no. as param, it will display as your current record
    this.paginationCallback(this.state.pageNumber);
  };

  paginationCallback(pageNumber) {
    let { search, sort } = this.state;

    if (search == "" && sort == "randomly") {
      this.props.fetchExhibitors(
        this.props.session,
        pageNumber,
        (callback) => {}
      );
    } else if (search == "" && sort == "az") {
      this.props.sortByName(this.props.session, sort, pageNumber);
    } else {
      this.props.searchExhibitors(this.props.session, search, pageNumber);
    }
    this.setState({ ...this.state, pageNumber });
  }

  exportUsers(JSONData) {
    var XLSX = require("xlsx");

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "Exhibitor.xlsx");
  }

  render() {
    let { deviceSize } = this.props;
    var sortBy = [
      { label: "Sort by Name: Randomly", value: "randomly" },
      { label: "Sort by Name: A-Z", value: "az" },
    ];

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <ContentIcon heading={HEADING_EXHIBITORS} />
          </div>

          <ul className="header-buttons">
            <li>
              <input
                className="form-control mapsearches content-table-header-searchinput"
                placeholder="Search"
                type="text"
                value={this.state.search}
                onChange={this.handleSearch}
              />
            </li>
            <li>
              <select
                className="form-control dropdown-height-border content-table-header-selectrandomly"
                placeholder="Sort by name"
                onChange={this.handleSortByName}
                value={this.state.sort}
              >
                {sortBy.map((object, index) => {
                  return (
                    <option
                      key={`${object.value}-${index}`}
                      value={object.value}
                    >
                      {object.label}
                    </option>
                  );
                })}
              </select>
            </li>

            <li>
              <AddExhibitor
                finishOperationsCallback={this.additionCallback}
                history={this.props.history}
              />
            </li>
            <li>
              <ExportExhibitor JSONToCSVConvertor={this.exportUsers} />
            </li>
            <li>
              <ImportExhibitorDialog
                finishOperationsCallback={this.additionCallback}
              />
            </li>
            <li>
              <InfoTutorial video="exhibitor.mp4" />
            </li>
          </ul>
        </div>
        <div className="clearfix" />
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <ExhibitorsList
              search={this.state.search}
              pageNumber={this.state.pageNumber}
              paginationCallback={this.paginationCallback}
              finishOperationsCallback={this.additionCallback}
              afterpagi={this.state.afterpagi}
              makepagistopped={this.makepagistopped}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  return {
    session: state.session,
    contentAvailable,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchExhibitors,
  searchExhibitors,
  sortByName,
  fetchUserList,
  fetchAllTickets,
  fetchSettings,
  fetchProductAllCategory,
  fetchProductAllSubCategory,
  getExhibitorCounts,
  fetchEventDetails,
})(Exhibitors);
